import { FormEvent, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { api } from '../api';

export function RegisterPage() {
  const [searchParams] = useSearchParams();
  const ref = searchParams.get('ref')?.trim() || undefined;
  const [email, setEmail] = useState('');
  const [consent, setConsent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [done, setDone] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await api.register(email, consent, ref);
      setDone(true);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Ошибка регистрации');
    } finally {
      setSubmitting(false);
    }
  }

  if (done) {
    return (
      <div className="auth-container">
        <a className="auth-logo" href="/">
          <img src="/logo.png" alt="OrbanVPN" width="72" height="72" />
          <span className="brand-name">OrbanVPN</span>
        </a>
        <h1>Готово</h1>
        <div className="card">
          <p>Мы отправили письмо со сгенерированным паролем на <strong>{email}</strong>.</p>
          <p className="muted">Если письмо не пришло в течение 5 минут — проверьте папку «Спам».</p>
          <Link to="/login" className="btn btn-block secondary" role="button">Перейти ко входу</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="auth-container">
      <a className="auth-logo" href="/">
        <img src="/logo.png" alt="OrbanVPN" width="72" height="72" />
        <span className="brand-name">OrbanVPN</span>
      </a>
      <h1>Регистрация</h1>
      <div className="card">
        <p className="muted">
          Введите email — мы пришлём сгенерированный пароль на почту. После входа его можно будет сменить.
        </p>
        <form onSubmit={onSubmit}>
          <div className="form-row">
            <label htmlFor="email">Email</label>
            <input id="email" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div className="form-row" style={{ flexDirection: 'row', alignItems: 'flex-start', gap: 8 }}>
            <input id="consent" type="checkbox" checked={consent} onChange={(e) => setConsent(e.target.checked)} />
            <label htmlFor="consent" style={{ color: 'inherit', fontSize: 14 }}>
              Я согласен(а) с <a href="/oferta.html" target="_blank" rel="noopener">офертой</a> и{' '}
              <a href="/privacy.html" target="_blank" rel="noopener">политикой конфиденциальности</a>
            </label>
          </div>
          {error && <div className="error">{error}</div>}
          <button type="submit" className="btn-block" disabled={submitting || !consent}>Зарегистрироваться</button>
        </form>
      </div>
      <div className="auth-meta">
        <Link to="/login">Уже есть аккаунт? Войти</Link>
      </div>
    </div>
  );
}
